import React from "react";
import { connect } from "react-redux";

import { TabNavigation, Logo } from "components";
import { MOVE_TAB } from "actions";

const Tab2 = props => {
  const selectedNo = () => {
    props.moveToNextTab(false);
  };
  const selectedYes = () => {
    props.moveToNextTab(true);
  };

  const { domainBaseColour, domain } = props;

  return (
    <div className="form_steps">
      <div className="form_steps--inner flex">
        <div className="full_column">
          <Logo />
          <TabNavigation />
          <div className="form_content">
            <h2 className="link_checkbox_container--title">{domain.Strings.tab2Title}</h2>
            <div className="link_checkbox_container">
              <span style={{ color: domainBaseColour }} onClick={selectedYes}>
                {domain.Strings.tab2Yes}
              </span>
              <span style={{ color: domainBaseColour }} onClick={selectedNo}>
                {domain.Strings.tab2No}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    moveToNextTab: tab2Answer => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab, tab2Answer })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab2);
